export const buildClients = (clients, profiles = []) => clients.map(client => buildClient(client, profiles));

export const buildClient = (client, profiles) => ({
    ...client,
    displayName: `${client.name} ${client.last_name}`,
    profile: profiles ? buildClientProfile(client.profile, profiles) : client.profile
});

const buildClientProfile = (user_profile, profiles) => profiles.find(profile => profile._id === user_profile[0]);

// Compañía con la que se buscan clientes al cargar un ticket. Un usuario de concesionario trabaja
// con todas las compañías del concesionario (dealer_companies): se busca en la del ticket y no en
// su company propia, que es una sola marca. Sin compañía del ticket sigue la regla del perfil.
export const clientSearchCompany = (loggedUser, ticketCompany) => {
    const dealerCompanies = loggedUser?.dealer_companies || [];
    if (dealerCompanies.length && ticketCompany?.value) {
        const match = dealerCompanies.find(
            c => c._id === ticketCompany.id || c?.crm_area?.identifier === ticketCompany.value
        );
        if (match) return match._id;
    }
    return loggedUser?.permission?.clients?.companies?.onlySame ? loggedUser.company?._id : undefined;
};
